import {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useAuth} from '../core/Auth'
import {ChangeCompany} from '../../apps/invoice-management/invoices-list/components/header/ChangeCompany'

export const ACCESS_RESTRICTED_EVENT = 'megapay:access:restricted'

const DEFAULT_MESSAGE =
  'ورود به این کسب‌وکار در این زمان یا از این نشانی برای حساب شما مجاز نیست. با مدیر کسب‌وکار تماس بگیرید.'

/**
 * «محدودیت ورود» (backend 1.0.0.642+): a request of a business that is closed to the user now (day, hour, address or
 * period) answers 403 ACCESS_RESTRICTED with the reason. The panel says it once, offers the user's other businesses
 * and signing out, instead of pages that fail one by one.
 */
export const AccessRestrictedNotice: FC = () => {
  const {currentUser, logout} = useAuth()
  const [message, setMessage] = useState<string>()

  useEffect(() => {
    const onRestricted = (event: Event) => {
      const detail = (event as CustomEvent<{message?: string}>).detail
      setMessage(
        typeof detail?.message === 'string' && detail.message.trim()
          ? detail.message
          : DEFAULT_MESSAGE
      )
    }
    window.addEventListener(ACCESS_RESTRICTED_EVENT, onRestricted)
    return () => window.removeEventListener(ACCESS_RESTRICTED_EVENT, onRestricted)
  }, [])

  if (!message) return null

  const others = (currentUser?.cpl || []).filter(
    (company) => company.id !== Number(currentUser?.cpi)
  )
  return (
    <Modal
      show
      centered
      onHide={() => setMessage(undefined)}
      aria-labelledby='access-restricted-title'
    >
      <Modal.Header closeButton closeLabel='بستن'>
        <Modal.Title id='access-restricted-title' as='h2' className='fs-4'>
          <i className='las la-user-clock text-warning me-2' aria-hidden='true'></i>
          دسترسی در این زمان مجاز نیست
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className='mb-4' role='alert'>
          {message}
        </p>
        {others.length > 0 && (
          <div>
            <div className='fw-bold fs-7 mb-2'>می‌توانید کسب‌وکار دیگری را انتخاب کنید:</div>
            <ChangeCompany />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button type='button' className='btn btn-light' onClick={() => window.location.reload()}>
          تلاش دوباره
        </button>
        <button
          type='button'
          className='btn btn-light-danger'
          onClick={() => {
            logout()
            window.location.replace('/auth/login')
          }}
        >
          خروج از حساب
        </button>
      </Modal.Footer>
    </Modal>
  )
}
